
export default () => ({
  formState: {
    isLoading: false,
    isShowed: true,
    hasError: false
  },
  formData: {
    email: null
  },
  formDataErrors: []
})
